import { render, staticRenderFns } from "./ship-method.vue?vue&type=template&id=40c91ea4&scoped=true"
import script from "./ship-method.vue?vue&type=script&lang=ts"
export * from "./ship-method.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c91ea4",
  null
  
)

export default component.exports